// SVG Icons
const DownloadIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </svg>
);

const CopyIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
  </svg>
);

export function InvoiceResult({ data }) {
  const invoiceData = data.invoice || data;

  const {
    ejercicio,
    moneda,
    fecha_factura,
    tipo_cambio,
    importe_neto,
    impuestos_iva,
    impuestos_otros,
    impuestos,
    importe_bruto,
    cuit_emisor,
    razon_social_emisor,
    cuit_receptor,
    razon_social_receptor,
    punto_de_venta,
    tipo_de_comprobante,
    numero_de_comprobante,
  } = invoiceData;

  const handleCopy = () => {
    navigator.clipboard.writeText(JSON.stringify(invoiceData, null, 2));
  };

  const handleDownload = () => {
    const blob = new Blob([JSON.stringify(invoiceData, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `document-${numero_de_comprobante || 'data'}.json`;
    a.click();
    URL.revokeObjectURL(url);
  };

  // Build fields array in the exact order shown in the image (2 columns)
  const fields = [
    { label: 'FISCAL YEAR', value: ejercicio },
    { label: 'CURRENCY', value: moneda },
    { label: 'INVOICE DATE', value: fecha_factura },
    { label: 'EXCHANGE RATE', value: tipo_cambio },
    { label: 'NET AMOUNT', value: importe_neto },
    { label: 'VAT', value: impuestos_iva },
    { label: 'OTHER TAXES', value: impuestos_otros },
    { label: 'TAXES', value: impuestos },
    { label: 'GROSS AMOUNT', value: importe_bruto },
    { label: 'ISSUER CUIT', value: cuit_emisor },
    { label: 'ISSUER NAME', value: razon_social_emisor },
    { label: 'RECIPIENT CUIT', value: cuit_receptor },
    { label: 'RECIPIENT NAME', value: razon_social_receptor },
    { label: 'POINT OF SALE', value: punto_de_venta },
    { label: 'DOCUMENT TYPE', value: tipo_de_comprobante },
    { label: 'DOCUMENT NUMBER', value: numero_de_comprobante },
  ];

  return (
    <div className="result-card-wrapper">
      <div className="result-card-header">
        <span>Extracted Data</span>
        <div className="result-card-actions">
          <button className="btn-action" onClick={handleDownload}>
            <DownloadIcon />
            Download
          </button>
          <button className="btn-action" onClick={handleCopy}>
            <CopyIcon />
            Copy
          </button>
        </div>
      </div>

      <div className="result-card-body">
        <div className="result-fields-title">Document fields</div>
        <div className="result-fields-grid">
          {fields.map((field, index) => (
            <div key={index} className="result-field">
              <span className="result-field-label">{field.label}</span>
              <span className="result-field-value">{field.value ?? '-'}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="result-card-footer">
        <span className="result-model-info">
          Model: <span>surus-factura-ainode</span>
        </span>
      </div>
    </div>
  );
}
